<template>
  <div class="nx-dayparting-calendar-rows v-calendar-daily__pane">
    <div class="v-calendar-daily__day-container">
      <div class="v-calendar-daily__intervals-body">
        <div v-for="(row, index) in rows" :key="row.uuid" class="v-calendar-daily__interval">
          <div class="nx-heading--level-2">{{ index + 1 }}</div>
        </div>
      </div>
      <template v-for="day in days" >
        <div :class="dayClasses(day)" :key="day.dayIdentifier">
          <div v-if="day.currentDay" class="nx-timer" :style="todayStyle"></div>
          <div v-for="row in rows"
               :key="row.uuid"
               class="v-calendar-daily__day-interval"
               style="background-color: rgba(0, 0, 0, 0.05);">
           <nx-dayparting-calendar-timeline></nx-dayparting-calendar-timeline>
            <div class="nx-dayparting-calendar-rows__events-container">
              <nx-dayparting-calendar-event v-for="(event, index) in rowFilteredEvents(row, day.events)"
                                            v-on="$listeners"
                                            :key="event.id"
                                            :style="{'z-index' : eventInverseIndex(index, day.events.length)}"
                                            :disabled="disabled"
                                            :event="event"></nx-dayparting-calendar-event>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import NxDaypartingCalendarEvent from '@/modules/board/dayparting/components/CalendarEvent';
import NxDaypartingCalendarTimeline from '@/modules/board/dayparting/components/CalendarTimeline';
import { Calendar } from 'dayspan';
import moment from 'moment';

export default {
  name: 'nx-dayparting-calendar-rows',
  components: { NxDaypartingCalendarTimeline, NxDaypartingCalendarEvent },
  props: {
    calendar: {
      type: Calendar,
      required: true,
    },
    rows: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    todayStyle() {
      const now = moment();
      const endOfToday = moment().endOf('day').set({ s: 0 });

      const startOfDay = now.clone().startOf('day');
      const minutesSinceMidnight = now.diff(startOfDay, 'minutes');
      const endOfTodayMinutes = endOfToday.diff(startOfDay, 'minutes');

      return {
        'margin-left': `${Math.ceil((minutesSinceMidnight * 100) / endOfTodayMinutes)}%`,
      };
    },
    days() {
      return this.calendar.days;
    },
  },
  methods: {
    /**
     * @param day { CalendarDay }
     * @returns { string[] }
     */
    dayClasses(day) {
      const classes = ['v-calendar-daily__day'];
      if (day.date < moment()) {
        classes.push('v-past');
      }
      if (day.currentDay) {
        classes.push('v-present');
      }
      if (day.date > moment()) {
        classes.push('v-future');
      }
      return classes;
    },
    eventInverseIndex(index, total) {
      // Get the index from a total items reversed index array example: [2, 1, 0][index]
      return Array.from(Array(total).keys()).reverse()[index];
    },
    rowFilteredEvents(row, events) {
      return events.filter(event => event.data.row === row.uuid);
    },
  },
};
</script>

<style lang="stylus">
.nx-dayparting-calendar-rows {
  .nx-timer {
    position: absolute;
    top: 0;
    height: 100%;
    outline: 2px solid #4ed19c;
    z-index: 2;
  }
  .v-calendar-daily__intervals-body {
    border: #e0e0e0 1px solid;
    .v-calendar-daily__interval {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:not(:last-child) {
        border-bottom: #e0e0e0 1px solid;
      }
    }
  }

  .v-calendar-daily__day {
    border-right: #e0e0e0 1px solid;
    border-bottom: #e0e0e0 1px solid;
    .v-calendar-daily__day-interval {
      height: 40px;
      position: relative;
    }
  }

  &__events-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: -1px;
  }
}
</style>
